import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';

const { SPACING } = Tokens;

const SPACING_6 = '0.375rem';
const LIST_HEIGHT = '2.25rem';
const LIST_ITEM_HEIGHT = '2rem';

export default {
  HorizontalList: styled.div`
    ${DEEP_BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    outline: none;
    padding: ${SPACING.SPACING_2};
    margin: ${SPACING.SPACING_0};
    min-height: ${LIST_HEIGHT};
    height: 100%;
  `,
  ListUnOrdered: styled.ul`
    list-style-type: none;
    padding: ${SPACING.SPACING_0};
    margin: ${SPACING.SPACING_0};
  `,
  HorizontalListItem: styled.li`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    list-style-type: none;
    outline: none;
    float: left;
    width: ${LIST_ITEM_HEIGHT};
    height: ${LIST_ITEM_HEIGHT};
    box-sizing: content-box;
    padding: ${SPACING.SPACING_0} ${SPACING_6};
    &:last-child {
      ${props => css`padding: ${(props.RTL || props.$rtl || props.rtl) ? `0 ${SPACING_6} 0 0` : `0 0 0 ${SPACING_6}`};`}
    }
    &:first-child {
      ${props => css`padding: ${(props.RTL || props.$rtl || props.rtl) ? `0 0 0 ${SPACING_6}` : `0 ${SPACING_6} 0 0`};`}
    }
  `,
};
